<div class="crear-periodontograma">
  <div class="acciones-top">
    <button mat-stroked-button type="button" (click)="empezarNuevo()">Empezar de cero</button>
    <button mat-stroked-button type="button" (click)="precargarUltimo()" [disabled]="!ultimoFecha">
      Continuar del anterior{{ ultimoFecha ? " (" + ultimoFecha + ")" : "" }}
    </button>
    <mat-button-toggle-group [(ngModel)]="denticion" class="denticion-toggle">
      <mat-button-toggle value="adulto">Adulto</mat-button-toggle>
      <mat-button-toggle value="nino">Niño</mat-button-toggle>
      <mat-button-toggle value="mixta">Mixta</mat-button-toggle>
    </mat-button-toggle-group>
  </div>

  <app-periodontograma-chart
    [estado]="estadoPerio"
    [mode]="'edit'"
    [denticion]="denticion"
    (dienteClick)="onDientePerioClick($event)"
  ></app-periodontograma-chart>

  <div class="acciones-bottom" *ngIf="mostrarGuardar">
    <button mat-flat-button class="btn-guardar-periodontograma" (click)="guardar()" [disabled]="guardando">
      Guardar
    </button>
  </div>
</div>
